<template>
    <div
        class="h-screen overflow-y-auto won-bg-gray-50 flex justify-center items-center pb-4"
    >
        <slot />
    </div>
</template>
